import _enUS from '../en-US/exchangeRate.json'
import _zhHK from '../zh-HK/exchangeRate.json'
import _zhCN from '../zh-CN/exchangeRate.json'

const enUS = { ..._enUS }
const zhHK = { ..._zhHK }
const zhCN = { ..._zhCN }

export default { enUS, zhHK, zhCN }
